module.exports = __webpack_public_path__ + "static/media/pragmatic4000m.905964ae.webp";